module.exports = __webpack_public_path__ + "img/ic-undo.39bc95ea.svg";